export default (function (_ref) {
  var colors = _ref.colors;
  return {
    base: {
      backgroundColor: '#c7d2dc',
      position: 'absolute',
      width: '1px'
    },
    blackStep: {
      backgroundColor: colors.yellowDark
    },
    lastStep: {
      transform: 'translateX(-1px)'
    },
    '@global': {
      '.step-emphasized-light': {
        '&::before': {
          backgroundColor: '#e4e4e4'
        }
      },
      '.step-emphasized-dark': {
        '&::before': {
          backgroundColor: colors.primaryDarker
        }
      }
    },
    emphasizedStep: {
      '&::before': {
        content: '""',
        height: '12px',
        width: '12px',
        borderRadius: '50%',
        position: 'absolute',
        left: '-6px',
        bottom: '-9px'
      }
    }
  };
});